import {
  ADD_KB,
  ADD_KB_FAILURE,
  FETCH_ALL_KB_SUCCESS,
  FETCH_KB_SECTIONS_SUCCESS,
  UPDATE_KB,
  UPDATE_KB_SUCCESS,
  DELETE_KB,
  DELETE_KB_SUCCESS,
  SYNC_KB_SUCCESS,
  SHOW_KB_SETTINGS_MODAL,
  SET_ACTIVE_KB,
  ADD_KB_SUCCESS
} from 'Actions/kb'

const initialState = {
  adding: false,
  updating: false,
  showModal: false,
  kbList: [],
  kb: {}
}

const kbList = (state = initialState, action) => {
  const payload = action.payload

  switch (action.type) {
    case ADD_KB:
      return {
        ...state,
        adding: true
      }

    case ADD_KB_SUCCESS:
    case ADD_KB_FAILURE: {
      return {
        ...state,
        adding: false
      }
    }

    case FETCH_ALL_KB_SUCCESS:
      return {
        ...state,
        kbList: payload.kbList
      }

    case FETCH_KB_SECTIONS_SUCCESS:
      return {
        ...state,
        kbSections: payload.kbSections
      }

    case UPDATE_KB:
      return {
        ...state,
        updating: true
      }

    case UPDATE_KB_SUCCESS:
      return {
        ...state,
        kb: payload.kb,
        updating: false
      }

    case DELETE_KB:
      return {
        ...state,
        updating: true
      }

    case DELETE_KB_SUCCESS:
      return {
        ...state,
        kb: payload.kb,
        updating: false,
        showModal: false
      }

    case SYNC_KB_SUCCESS:
      return {
        ...state,
        kbList: state.kbList.map((kb) => (kb.id === payload.kbId ? { ...kb, sync_status: 'in_progress' } : kb))
      }

    case SHOW_KB_SETTINGS_MODAL:
      return {
        ...state,
        showModal: payload.showModal
      }

    case SET_ACTIVE_KB:
      return {
        ...state,
        kb: payload.kb
      }

    default:
      return state
  }
}

export default kbList
